export default __webpack_public_path__ + "static/media/state-of-design-3x.6e84f8fc.png";